export const LOAD_GIFT_CARD_CHECKOUT = 'LOAD_GIFT_CARD_CHECKOUT';
export const LOAD_GIFT_CARD_CHECKOUT_SUCCESS = 'LOAD_GIFT_CARD_CHECKOUT_SUCCESS';
export const LOAD_GIFT_CARD_CHECKOUT_FAILED = 'LOAD_GIFT_CARD_CHECKOUT_FAILED';
